/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroups,
    GetFactoriesByGroupID,
    GetRouteByFactoryID,
    GetAllProductsDetails,
    GetViewCropForcastingDetails
};

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetRouteByFactoryID(factoryID) {
    const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + parseInt(factoryID));
    return response.data;
}

async function GetAllProductsDetails() {
    const response = await CommonGet('/api/Product/GetAllProductsDetails', null);
    return response.data;
}

async function GetViewCropForcastingDetails(factoryID, productID) {
    const response = await CommonGet('/api/CropForcasting/GetViewCropForcastingDetails', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0) + '&productID=' + parseInt(productID));
    return response.data;
}
